import { render, staticRenderFns } from "./three-step.vue?vue&type=template&id=b6f0b3f2&scoped=true"
import script from "./three-step.vue?vue&type=script&lang=js"
export * from "./three-step.vue?vue&type=script&lang=js"
import style0 from "./three-step.vue?vue&type=style&index=0&id=b6f0b3f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f0b3f2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonImage: require('/builds/wj/fe/wenjuan-homesite/components/common/image.vue').default,CommonButton: require('/builds/wj/fe/wenjuan-homesite/components/common/button.vue').default})
